import { label } from "aws-amplify";
import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";
import styles from "./FilterDrawer.module.scss";

interface FilterFormParmsType {
  materialTypeSearchValue?: string;
  materialCategorySearchValue?: string;
  setMaterialTypeSearchValue?: () => void;
  setMaterialCategorySearchValue?: () => void;
}

export const DrawerConstants = {
  TITLE: "Filter",
  WIDTH: "30rem",
  BUTTON: {
    CLEAR_FILTER_LABEL: "Clear Filters",
    CANCEL_LABEL: "Cancel",
    APPLY_LABEL: "Apply",
  },
  MESSAGES: {
    REQUIRED: "required",
    NUMBERS_ONLY: "Only number allowed",
  },
};

export const getFormInputFields = (params: FilterFormParmsType) => [
  {
    name: "category",
    label: "Material Category",
    placeholder: "Select",
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    setSearch: params.setMaterialCategorySearchValue,
    searchValue: params.materialCategorySearchValue,
  },
  {
    name: "materialType",
    label: "Material Type",
    placeholder: "Select",
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    setSearch: params.setMaterialTypeSearchValue,
    searchValue: params.materialTypeSearchValue,
  },
  {
    name: "addressField",
    label: "Address",
    placeholder: "Search address",
    type: InputfieldTypes.GOOGLE,
  },
  {
    name: "radius",
    label: "Search Radius",
    placeholder: "Select",
    type: InputfieldTypes.NUMBER,
    addonAfter: "Miles",
  },
];
